/** Current dealer-enabled Sundance catalog, captured 2026-10-17. Only 680/780/880 are enabled in the dealer feed. */
export const sundanceModels = [
  {
    "id": "Altamar",
    "name": "Altamar – 880 Series",
    "series": "880",
    "seats": "5–6",
    "capacity": 6,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/altamar/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/altamar",
    "dimensions": {
      "length_in": 84,
      "width_in": 84,
      "height_in": 37
    },
    "jets": 40
  },
  {
    "id": "Aspen",
    "name": "Aspen – 880 Series",
    "series": "880",
    "seats": "7–8",
    "capacity": 8,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/aspen/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/aspen",
    "dimensions": {
      "length_in": 89,
      "width_in": 110,
      "height_in": 40
    },
    "jets": 66
  },
  {
    "id": "Cameo",
    "name": "Cameo – 880 Series",
    "series": "880",
    "seats": "5–6",
    "capacity": 6,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/cameo/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/cameo",
    "dimensions": {
      "length_in": 89,
      "width_in": 89,
      "height_in": 37
    },
    "jets": 53
  },
  {
    "id": "Capri",
    "name": "Capri – 880 Series",
    "series": "880",
    "seats": "2–3",
    "capacity": 3,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/capri/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/capri",
    "dimensions": {
      "length_in": 69,
      "width_in": 82,
      "height_in": 31
    },
    "jets": 36
  },
  {
    "id": "Marin",
    "name": "Marin – 880 Series",
    "series": "880",
    "seats": "4–5",
    "capacity": 5,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/marin/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/marin",
    "dimensions": {
      "length_in": 76,
      "width_in": 91,
      "height_in": 34
    },
    "jets": 45
  },
  {
    "id": "Optima",
    "name": "Optima – 880 Series",
    "series": "880",
    "seats": "6–7",
    "capacity": 7,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/optima/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/optima",
    "dimensions": {
      "length_in": 89,
      "width_in": 89,
      "height_in": 37
    },
    "jets": 49
  },
  {
    "id": "Vistamar",
    "name": "Vistamar – 880 Series",
    "series": "880",
    "seats": "5–6",
    "capacity": 6,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/vistamar/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/vistamar",
    "dimensions": {
      "length_in": 84,
      "width_in": 84,
      "height_in": 37
    },
    "jets": 41
  },
  {
    "id": "Bristol",
    "name": "Bristol – 780 Series",
    "series": "780",
    "seats": "5–6",
    "capacity": 6,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/bristol/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/bristol",
    "dimensions": {
      "length_in": 84,
      "width_in": 84,
      "height_in": 38
    },
    "jets": 38
  },
  {
    "id": "Chelsee",
    "name": "Chelsee – 780 Series",
    "series": "780",
    "seats": "6–7",
    "capacity": 7,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/chelsee/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/chelsee",
    "dimensions": {
      "length_in": 89,
      "width_in": 89,
      "height_in": 38
    },
    "jets": 40
  },
  {
    "id": "Dover",
    "name": "Dover – 780 Series",
    "series": "780",
    "seats": "2–3",
    "capacity": 3,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/dover/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/dover",
    "dimensions": {
      "length_in": 69,
      "width_in": 82,
      "height_in": 31
    },
    "jets": 23
  },
  {
    "id": "Hamilton",
    "name": "Hamilton – 780 Series",
    "series": "780",
    "seats": "5–6",
    "capacity": 6,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/hamilton/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/hamilton",
    "dimensions": {
      "length_in": 89,
      "width_in": 89,
      "height_in": 38
    },
    "jets": 41
  },
  {
    "id": "Montclair",
    "name": "Montclair – 780 Series",
    "series": "780",
    "seats": "4–5",
    "capacity": 5,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/montclair/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/montclair",
    "dimensions": {
      "length_in": 75,
      "width_in": 91,
      "height_in": 35
    },
    "jets": 30
  },
  {
    "id": "Alicia",
    "name": "Alicia - 680 Series",
    "series": "680",
    "seats": "2–3",
    "capacity": 3,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/alicia/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/alicia",
    "dimensions": {
      "length_in": 69,
      "width_in": 80,
      "height_in": 33
    },
    "jets": 21
  },
  {
    "id": "Edison",
    "name": "Edison – 680 Series",
    "series": "680",
    "seats": "6",
    "capacity": 6,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/edison/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/edison",
    "dimensions": {
      "length_in": 84,
      "width_in": 84,
      "height_in": 36
    },
    "jets": 36
  },
  {
    "id": "McKinley",
    "name": "McKinley – 680 Series",
    "series": "680",
    "seats": "6–7",
    "capacity": 7,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/mckinley/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/mckinley",
    "dimensions": {
      "length_in": 89,
      "width_in": 89,
      "height_in": 36
    },
    "jets": 42
  },
  {
    "id": "Peyton",
    "name": "Peyton – 680 Series",
    "series": "680",
    "seats": "6",
    "capacity": 6,
    "seatType": "Lounge",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/peyton/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/peyton",
    "dimensions": {
      "length_in": 84,
      "width_in": 84,
      "height_in": 36
    },
    "jets": 34
  },
  {
    "id": "Prado",
    "name": "Prado - 680 Series",
    "series": "680",
    "seats": "4–5",
    "capacity": 5,
    "seatType": "Open Seating",
    "image": "https://pegasus-spas.dealerhottubpages.com/sites/dealerhottubpages.com/pages/images/sundance/products/prado/hero.jpg",
    "href": "https://pegasus-spas.dealerhottubpages.com#/product/prado",
    "dimensions": {
      "length_in": 80,
      "width_in": 80,
      "height_in": 33
    },
    "jets": 26
  }
]
